import { Trans } from '@lingui/macro'
import { Signuture } from './FormSignature'

export const FormSignaturePrintEditor = props => {
  const signature = <Trans>Signature Placeholder</Trans>
  return <Signuture {...props} signature={signature} isPrintEditor />
}
